import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import EmptyLayout from './layouts/EmptyLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import DashboardApp from './pages/DashboardApp';
import Products from './pages/Products';
import Blog from './pages/Blog';
import User from './pages/User';
import NotFound from './pages/Page404';
import Loader from './pages/Loader';
import token from './helpers/TokenDecoder';
import ResetPassword from './pages/ResetPassword';
import { UserListing, RoleAddEdit } from './components/Modules/UserRole/Pages';
import { ProductCategoryListing, Addedit } from './components/Modules/ProductCategory/Pages';
import { ProductListing, ProductAddEdit } from './components/Modules/Product/Pages';
import { PermissionListing } from './components/Modules/Rolepermissions/Pages';
import { FarmerListing, FarmerAddEdit } from './components/Modules/Farmer/Pages';
import { FarmerBulkUpload } from './components/Modules/FarmerBulkUpload/Pages';
import { CropForcastListing } from './components/Modules/CropForcastAddEdit/Pages';
import { CropForcastView } from './components/Modules/CropForcastView/Pages';
import { ViewOrder } from './components/Modules/Order/Pages';
import { PriceOrderUpdate } from './components/Modules/PriceAndOrderUpdate/Pages';
import { PriceView, PriceViewProduct } from './components/Modules/PriceView/Pages';
import { SupplierView } from './components/Modules/AddSeller/Pages';
import { PriceUpdate } from './components/Modules/PriceUpdate/Pages';
import { ApproveReturnInvoice } from './components/Modules/ApproveReturnInvoice/Pages';
import { ViewInvoice } from './components/Modules/ViewProductWiseInvoice/Pages';
import { ViewInvoiceCollectionWise } from './components/Modules/ReturnInvoiceCollectionCenter/Pages';
import { ReturnQuantitesReAssign } from './components/Modules/ReturnQuantitiesReAssign/Pages';
import { OrderAmendmentView } from './components/Modules/OrderAmendment/Pages';
import { OutletReport } from './components/Modules/OutletReport/Pages';
import { CropDetailsBreakdown } from './components/Modules/CropDetailsBreakdown/Pages';
import { OutletWiseReport } from './components/Modules/OutletWiseReport/Pages';
import { ProductWiseOutletDemandDetailsReport } from './components/Modules/ProductWiseOutletDemandDetailsReport/Pages';
import { CollectionReport } from './components/Modules/CollectionCenterReport/Pages';
import {
  ProductLifeCycleListing,
  ProductLifeCycleAddEdit
} from './components/Modules/ProductLifeCycle/Pages';
import { SupplierProductReport } from './components/Modules/SupplierProductReport/Pages';
import { ProductWiseReport } from './components/Modules/ProductWiseReport/Pages';
import { CollectionProductReport } from './components/Modules/CollectionCenterProductReport/Pages';
import { ProductDemandDetailsReport } from './components/Modules/ProductDemandDetailsReport/Pages';
import { CropDetailsUpdate } from './components/Modules/CropDetailsUpdate/Pages';
import { FarmerProductPlotsView } from './components/Modules/FarmerProductPlots/Pages';
import {
  OperationEntityListing,
  OperationEntityAddEdit
} from './components/Modules/OperationEntity/Pages';
import { COPReport } from './components/Modules/COPReport/Pages';
import { ChangePassword } from './components/authentication/changePassword/Pages';
import { Configuration } from './components/Modules/Configuration/Pages';
import { ViewGrnInformation } from './components/Modules/ViewGrnInformation/Pages';
import { QRTagGenaration } from './components/Modules/QRTagGenaration/Pages';
import { QRCodePrint } from './components/Modules/QRCodePrint/Pages';
import { ViewOrderOutletDetailsByProductWise } from './components/Modules/ViewOrderOutletDetailsProductwise/Pages'
import { ViewOutletOrder } from './components/Modules/ViewOutletOrder/Pages';
import { OutletAddEdit, OutletListing } from './components/Modules/OutletScreen/Pages';
import { ViewFarmerAvailability } from './components/Modules/FarmerAvailability/Pages';
import { CropwiseAvailability } from './components/Modules/CropwiseAvailabilityReport/Pages';
import { CropWiseTransaction } from './components/Modules/CropWiseTransaction/Pages';
import { CollectionWiseTransaction } from './components/Modules/CollectionCenterWiseTransaction/Pages';
import { FarmerWiseTransaction } from './components/Modules/FarmerWiseTransactionReport/Pages';
import { ProductDemandSupply } from './components/Modules/ProductDemandSupply/Pages';
import { ViewCropForecast } from './components/Modules/ViewCropForecast/Pages';
import { DailyPerformOrdersView } from './components/Modules/DailyPerformOrdersView/Pages';
import { SpecialProductCategoryListing, AddEdit } from './components/Modules/SpecialProductCategory/Pages';
import { DeductionTemplateListing, DeductionTemplateAddEdit } from './components/Modules/DeductionTemplate/Pages';
import { FarmerOnboardingView } from './components/Modules/FarmerOnboardingReport/Pages';
import { AddHartiPrice } from './components/Modules/AddHartiPrice/Pages';
import { GoodsReceivedNote } from './components/Modules/GoodsReceivedNote/Pages';
import { AddSpecialOrderListing, AddSpecialOrderAddEdit } from './components/Modules/AddSpecialOrder/Pages';
import { ViewSpecialOrderListing } from './components/Modules/ViewSpecialOrder/Pages';
import { GoodsReceivedNoteApproval } from './components/Modules/GoodsReceivedNoteApproval/Pages';
import { PriceNegotiationAuditReport } from './components/Modules/PriceNegotiationAuditReport/Pages';
import { PriceNegotiationAuditSummaryReport } from './components/Modules/PriceNegotiationAuditSummaryReport/Pages';
import { FCCPurchasePriceVariationReport } from './components/Modules/FCCPurchasePriceVariationReport/Pages';
import { VehicleMasterListing, VehicleMasterAddEdit } from './components/Modules/VehicleMaster/Pages';
import { VCCOrderReportView } from './components/Modules/VCCOrderReport/Pages';
import { FDC2ndApprovedFarmerDetailsReport } from './components/Modules/FarmerDetailsReport/Pages';
import { AddCustomerOrders } from './components/Modules/CustomerOrdersBulk/Pages';
import { EarlyFinishApprovalListing } from './components/Modules/EarlyFinishApproval/Pages';
import { PlantingDetailsReport } from './components/Modules/PlantingDetailsReport/Pages';
import { PurchasingHistoryReport } from './components/Modules/PurchasingHistoryReport/Pages';
import { GrnSummaryView } from './components/Modules/GrnSummaryReport/Pages';
import { CollectorCropUpdate } from './components/Modules/CollectorCropUpdate/Pages';
import { SuppliedQtyagainstCultivatedQtyReport } from './components/Modules/SuppliedQtyagainstCultivatedQtyReport/Pages';
import { FCCActivitySummaryReport } from './components/Modules/FCCActivitySummaryReport/Pages';
import { YtdAndMtdSummaryView } from './components/Modules/YTDAndMTDSummaryReport/Pages';
import { DailyPurchasingEfficiencySummaryView } from './components/Modules/DailyPurchasingEfficiencySummaryReport/Pages';
import { GTNWiseSummaryView } from './components/Modules/GTNWiseSummaryReport/Pages';
import { GRNSummaryApproval } from './components/Modules/GRNSummaryApproval/Pages';
import { ReinitiatePayment } from './components/Modules/ReinitiatePayment/Pages';
import { SurplusBulkUpload } from './components/Modules/SurplusBulkUpload/Pages';
import { AddOperationCost } from './components/Modules/AddOperationCost/Pages';
import { UncompletedProductListView } from './components/Modules/UncompletedProductListReport/Pages';
import { FinancialGRNReport } from './components/Modules/FinancialGRNReport/Pages';
import SupplierPaymentVerificationReportView from './components/Modules/SupplierPaymentVerificationReport/Pages/Listing';
import { FarmersAndCollectorsWisePurchaseSummaryReport } from './components/Modules/FarmersAndCollectorsWisePurchaseSummaryReport/Pages';
import { QuantityBoughtAgainstPurchaseOrderReport } from './components/Modules/QuantityBoughtAgainstPurchaseOrderReport/Pages';
import { CategoryWiseQtyBoughtAgainstPurchaseOrder } from './components/Modules/CategoryWiseQuantityBoughtAgainstPurchaseOrder/Pages';
import { NetBenefitOfFCCPurchasesReport } from './components/Modules/NetBenefitOfFCCPurchasesReport/Pages';
import { AvailabilityAgainstRequirement } from './components/Modules/AvailabilityAgainstRequirementReport/Pages';
import { PriceComparisonReport } from './components/Modules/PriceComparisonReport/Pages';
import { PriceApprovalReport } from './components/Modules/PriceApprovalReport/Pages';
import { MarketAddEdit, MarketListing } from './components/Modules/MarketScreen/Pages';
import { MarketPriceAddEdit, MarketPriceListing } from './components/Modules/MarketPriceScreen/Pages';
import FCCIQVsOQReport from './components/Modules/FCCIQVsOQReport/Pages/Report';
import { FDCVehicleUtilizationView } from './components/Modules/FDCVehicleUtilizationReport/Pages';
import { AnnualPlanForFCCReport } from './components/Modules/AnnualPlanForFCCReport/Pages';
import FinalStatusofSuplierPaymentReport from './components/Modules/FinalStatusofSuplierPaymentReport/Pages/Listing';
import UncompleteGRNReport from './components/Modules/UncompleteGRNReport/Pages/Listing';
import { OrderAllocationConfigurationListing, OrderAllocationConfigurationAddEdit } from './components/Modules/OrderAllocationConfiguration/Pages';
import { FDCInboundTransactionsReport } from './components/Modules/FDCInboundTransactionsReport/Pages';
import PricingListing from './components/Modules/Pricing/Pages/Listing';
import { ViewCustomerOrdersOutletWise } from './components/Modules/CustomerOrdersOutletWise/Pages';
import { ViewOutletOrders } from './components/Modules/ViewOutletOrders/Pages';
import { RouteListing, RouteAddEdit } from './components/Modules/Route/Pages';
import FCCInboundTransactionsReportSKUwise from './components/Modules/FCCInboundTransactionsReportSKUwise/Pages/report';
import { ViewFDCFCCOutboundInvoice } from './components/Modules/FDCFCCOutboundInvoice/Pages';
import { QuantityVarianceReport } from './components/Modules/QuantityVarianceReport/Pages';
import GradeMasterListing from './components/Modules/GradeMaster/Pages/Listing';
import GradeMasterAddEdit from './components/Modules/GradeMaster/Pages/AddEdit';
import { StockBalanceReport } from './components/Modules/StockBalanceReport/Pages';
import SupplierPaymentAuditReport from './components/Modules/SupplierPaymentAuditReport/Pages/Listing';
import { ViewOrderDetails } from './components/Modules/OrderDetails/Pages';
import { RejectGRNDetailReport } from './components/Modules/RejectGRNDetailReport/Pages';
import { PendingPackageDetailsReport } from './components/Modules/PendingPackageDetailReport/Pages';
import { OrderReallocationBreakdownReport } from './components/Modules/OrderReallocationBreakdownReport/Pages';
import { CustomerMasterListing, CustomerMasterAddEdit } from './components/Modules/CustomerMaster/Pages';
import CustomerTypeMappingAddEdit from './components/Modules/CustomerTypeMapping/Pages/AddEdit';
import CustomerTypeMappingListing from './components/Modules/CustomerTypeMapping/Pages/Listing';
import { InventoryHistoryReport } from './components/Modules/InventoryHistoryReport/Pages';
import { CustomerOrderPanelListing, CustomerOrderPanelAddEdit } from './components/Modules/CustomerOrderPanel/Pages';
import StockManagement from './components/Modules/StockManagement/Pages/Listing';
import { CustomerOutletWiseOrderHistoryReport } from './components/Modules/CustomerOutletWiseOrderHistoryReport/Pages';
import { StockAdjustmentListing, StockAdjustmentAddEdit } from './components/Modules/StockAdjustment/Pages';

export default function Router() {
  if (token.isTokenExists()) {
    return useRoutes([
      {
        path: '/',
        element: <LogoOnlyLayout />,
        children: [
          { path: 'login', element: <Login /> },
          { path: '404', element: <NotFound /> },
          { path: '/', element: <Navigate to="/loader" /> },
          { path: 'loader', element: <Loader /> },
          { path: '*', element: <Navigate to="/404" /> }
        ]
      },
      {
        path: '/dashboard',
        element: <DashboardLayout />,
        children: [
          { path: '/', element: <Navigate to="/dashboard/loader" replace /> },
          { path: 'app', element: <DashboardApp /> },
          {
            path: 'user',
            children: [
              { path: '/', element: <User /> },
              { path: 'register/:userID', element: <Register /> },
              { path: 'resetPassword/:userID', element: <ResetPassword /> },
              { path: 'changePassword/', element: <ChangePassword /> }
            ]
          },
          {
            path: 'userRole',
            children: [
              { path: '/', element: <UserListing /> },
              { path: 'AddEdit/:roleID', element: <RoleAddEdit /> }
            ]
          },
          {
            path: 'productcategory',
            children: [
              { path: '/listing', element: <ProductCategoryListing /> },
              { path: 'addedit/:categoryID', element: <Addedit /> }
            ]
          },
          {
            path: 'product',
            children: [
              { path: '/listing', element: <ProductListing /> },
              { path: 'addedit/:productID', element: <ProductAddEdit /> }
            ]
          },
          {
            path: 'rolePermission',
            children: [
              { path: 'listing/:roleID/:roleLevelID/:roleName', element: <PermissionListing /> }
            ]
          },
          {
            path: 'farmer',
            children: [
              { path: '/', element: <FarmerListing /> },
              { path: 'addedit/:farmerID/:farmerCollectionCenterID', element: <FarmerAddEdit /> }
            ]
          },
          {
            path: 'customerOrdersView',
            children: [{ path: '/', element: <ViewOrder /> }]
          },
          {
            path: 'productWiseCollectionCenterDemandDetailsReport',
            children: [{ path: '/', element: <ProductWiseReport /> }]
          },
          {
            path: 'cropDetailsBreakdown',
            children: [{ path: '/', element: <CropDetailsBreakdown /> }]
          },
          {
            path: 'cropDetailsUpdate',
            children: [{ path: '/', element: <CropDetailsUpdate /> }]
          },
          {
            path: 'collectionReport',
            children: [{ path: '/', element: <CollectionReport /> }]
          },
          {
            path: 'outletReport',
            children: [{ path: '/', element: <OutletReport /> }]
          },
          {
            path: 'outletwiseReport',
            children: [{ path: '/', element: <OutletWiseReport /> }]
          },
          {
            path: 'viewInvoiceReportProductWise',
            children: [{ path: '/', element: <ViewInvoice /> }]
          },
          {
            path: 'viewcollectionCenterINvoice',
            children: [{ path: '/', element: <ViewInvoiceCollectionWise /> }]
          },
          {
            path: 'farmerBulkUpload',
            children: [{ path: '/', element: <FarmerBulkUpload /> }]
          },
          {
            path: 'priceUpdate',
            children: [{ path: '/', element: <PriceUpdate /> }]
          },
          {
            path: 'approveReturnInvoice',
            children: [{ path: '/', element: <ApproveReturnInvoice /> }]
          },
          {
            path: 'returnQuantitesReAllocate',
            children: [{ path: '/', element: <ReturnQuantitesReAssign /> }]
          },
          {
            path: 'productWiseOutletDemandDetailsReport',
            children: [{ path: '/', element: <ProductWiseOutletDemandDetailsReport /> }]
          },
          {
            path: 'productDemandDetailsReport',
            children: [{ path: '/', element: <ProductDemandDetailsReport /> }]
          },
          {
            path: 'collectionCenterWiseProductDemandReport',
            children: [{ path: '/', element: <CollectionProductReport /> }]
          },
          {
            path: 'createCropForcast',
            children: [{ path: '/', element: <CropForcastListing /> }]
          },
          {
            path: 'viewCropForecast',
            children: [{ path: '/', element: <CropForcastView /> }]
          },
          {
            path: 'priceOrderUpdate',
            children: [{ path: '/', element: <PriceOrderUpdate /> }]
          },
          {
            path: 'collectionCenterWise',
            children: [{ path: '/', element: <PriceView /> }]
          },
          {
            path: 'productWise',
            children: [{ path: '/', element: <PriceViewProduct /> }]
          },
          {
            path: 'collectionCenterVice',
            children: [{ path: '/', element: <PriceView /> }]
          },
          {
            path: 'supplierProductDemandDetailsReport',
            children: [{ path: '/', element: <SupplierProductReport /> }]
          },
          {
            path: 'viewFCCOrders',
            children: [{ path: '/', element: <OrderAmendmentView /> }]
          },
          {
            path: 'productLifeCycle',
            children: [
              { path: '/', element: <ProductLifeCycleListing /> },
              { path: 'addedit/:productLifeCycleID', element: <ProductLifeCycleAddEdit /> }
            ]
          },
          {
            path: 'farmerProductPlots',
            children: [{ path: '/', element: <FarmerProductPlotsView /> }]
          },
          {
            path: 'operationEntity',
            children: [
              { path: '/', element: <OperationEntityListing /> },
              { path: 'addedit/:operationEntityID', element: <OperationEntityAddEdit /> }
            ]
          },
          {
            path: 'Configuration',
            children: [{ path: '/', element: <Configuration /> }]
          },
          {
            path: 'viewQRTagGenaration',
            children: [{ path: '/', element: <QRTagGenaration /> }]
          },
          {
            path: 'PrintQrCode',
            children: [{ path: '/', element: <QRCodePrint /> }]
          },
          { path: 'loader', element: <Loader /> },
          { path: 'products', element: <Products /> },
          { path: 'blog', element: <Blog /> },
          {
            path: 'copreport',
            children: [
              { path: '/', element: <COPReport /> }
            ]
          },
          {
            path: 'ViewGrnInformation',
            children: [
              { path: '/', element: <ViewGrnInformation /> }
            ]
          },
          {
            path: 'cropwiseAvailability',
            children: [
              { path: '/', element: <CropwiseAvailability /> }
            ]
          },
          {
            path: 'viewOutletOrderProductwise',
            children: [
              { path: '/', element: <ViewOrderOutletDetailsByProductWise /> }
            ]
          },
          {
            path: 'viewOutletOrderReport',
            children: [
              { path: '/', element: <ViewOutletOrder /> }
            ]
          },
          {
            path: 'ViewOutlet',
            children: [
              { path: '/', element: <OutletListing /> },
              { path: 'addedit/:operationEntityID', element: <OutletAddEdit /> }
            ]
          },
          {
            path: 'farmerAvailability',
            children: [
              { path: '/', element: <ViewFarmerAvailability /> }
            ]
          },
          {
            path: 'farmerCropWiseTransaction',
            children: [
              { path: '/', element: <CropWiseTransaction /> }
            ]
          },
          {
            path: 'farmerCollectionCenterWiseTransaction',
            children: [
              { path: '/', element: <CollectionWiseTransaction /> }
            ]
          },
          {
            path: 'farmerWiseTransaction',
            children: [
              { path: '/', element: <FarmerWiseTransaction /> }
            ]
          },
          {
            path: 'productDemandSupply',
            children: [
              { path: '/', element: <ProductDemandSupply /> }
            ]
          },
          {
            path: 'cropForecastView',
            children: [
              { path: '/', element: <ViewCropForecast /> }
            ]
          },
          {
            path: 'dailyPerformOrdersView',
            children: [
              { path: '/', element: <DailyPerformOrdersView /> }
            ]
          },
          {
            path: 'specialProductCategory',
            children: [
              { path: '/', element: <SpecialProductCategoryListing /> },
              { path: 'addedit/:categoryID', element: <AddEdit /> }
            ]
          },
          {
            path: 'deductionTemplate',
            children: [
              { path: '/', element: <DeductionTemplateListing /> },
              { path: 'addedit/:operationEntityID', element: <DeductionTemplateAddEdit /> }
            ]
          },
          {
            path: 'addedSupplierView',
            children: [
              { path: '/', element: <SupplierView /> }
            ]
          },
          {
            path: 'supplierOnboardingDetailsReport',
            children: [
              { path: '/', element: <FarmerOnboardingView /> }
            ]
          },
          {
            path: 'hartiPriceBulkUpload',
            children: [
              { path: '/', element: <AddHartiPrice /> }
            ]
          },
          {
            path: 'GoodsReceivedNote',
            children: [
              { path: '/', element: <GoodsReceivedNote /> }
            ]
          },
          {
            path: 'AddSpecialOrder',
            children: [
              { path: '/', element: <AddSpecialOrderListing /> },
              { path: 'addedit/:specialOrderID', element: <AddSpecialOrderAddEdit /> }
            ]
          },
          {
            path: 'ViewSpecialOrder',
            children: [
              { path: '/', element: <ViewSpecialOrderListing /> }
            ]
          },
          {
            path: 'GoodsReceivedNoteApproval',
            children: [
              { path: '/', element: <GoodsReceivedNoteApproval /> }
            ]
          },
          {
            path: 'priceNegotiationAuditReport',
            children: [
              { path: '/', element: <PriceNegotiationAuditReport /> }
            ]
          },
          {
            path: 'PriceNegotiationAuditSummaryReport',
            children: [
              { path: '/', element: <PriceNegotiationAuditSummaryReport /> }
            ]
          },
          {
            path: 'FCCPurchasePriceVariationReport',
            children: [
              { path: '/', element: <FCCPurchasePriceVariationReport /> }
            ]
          },
          {
            path: 'VehicleMaster',
            children: [
              { path: '/', element: <VehicleMasterListing /> },
              { path: 'addedit/:vehicleID', element: <VehicleMasterAddEdit /> }
            ]
          },
          {
            path: 'fccActivityReport',
            children: [
              { path: '/', element: <VCCOrderReportView /> }
            ]
          },
          {
            path: 'FDC2ndApprovedFarmerDetailsReport',
            children: [{ path: '/', element: <FDC2ndApprovedFarmerDetailsReport /> }]
          },
          {
            path: 'customerOrderBulkUpload',
            children: [
              { path: '/', element: <AddCustomerOrders /> }
            ]
          },
          {
            path: 'EarlyFinishApproval',
            children: [
              { path: '/', element: <EarlyFinishApprovalListing /> }
            ]
          },
          {
            path: 'PlantingDetailsReport',
            children: [
              { path: '/', element: <PlantingDetailsReport /> }
            ]
          },
          {
            path: 'YTDandMTDSummaryReport',
            children: [
              { path: '/', element: <YtdAndMtdSummaryView /> }
            ]
          },
          {
            path: 'DailyPurchasingEfficiencySummaryReport',
            children: [
              { path: '/', element: <DailyPurchasingEfficiencySummaryView /> }
            ]
          },
          {
            path: 'FDCVehicleUtilization',
            children: [
              { path: '/', element: <FDCVehicleUtilizationView /> }
            ]
          },
          {
            path: 'GTNWiseSummaryReport',
            children: [
              { path: '/', element: <GTNWiseSummaryView /> }
            ]
          },

          {
            path: 'GrnSummaryReport',
            children: [
              { path: '/', element: <GrnSummaryView /> }
            ]
          },
          {
            path: 'purchasingHistoryReport',
            children: [
              { path: '/', element: <PurchasingHistoryReport /> }
            ]
          },
          {
            path: 'CollectorCropUpdate',
            children: [
              { path: '/', element: <CollectorCropUpdate /> }
            ]
          },
          {
            path: 'suppliedQtyagainstCultivatedQtyReport',
            children: [
              { path: '/', element: <SuppliedQtyagainstCultivatedQtyReport /> }
            ]
          },
          {
            path: 'fccActivitySummaryReport',
            children: [
              { path: '/', element: <FCCActivitySummaryReport /> }
            ]
          },
          {
            path: 'financialGrnReport',
            children: [
              { path: '/', element: <FinancialGRNReport /> }
            ]
          },
          {
            path: 'GRNSummaryApproval',
            children: [
              { path: '/', element: <GRNSummaryApproval /> }
            ]
          },
          {
            path: 'ReinitiatePayment',
            children: [
              { path: '/', element: <ReinitiatePayment /> }
            ]
          },
          {
            path: 'surplusBulkUpload',
            children: [
              { path: '/', element: <SurplusBulkUpload /> }
            ]
          },
          {
            path: 'UncompletedProductListReport',
            children: [
              { path: '/', element: <UncompletedProductListView /> }
            ]
          },
          {
            path: 'operationCostBulkUpload',
            children: [
              { path: '/', element: <AddOperationCost /> }
            ]
          },
          {
            path: 'supplierpaymentverification',
            children: [
              { path: '/', element: <SupplierPaymentVerificationReportView /> }
            ]
          }
          , {
            path: 'farmersAndCollectorsWisePurchaseSummaryReport',
            children: [
              { path: '/', element: <FarmersAndCollectorsWisePurchaseSummaryReport /> }
            ]
          },
          {
            path: 'quantityBoughtAgainstPurchaseOrderReport',
            children: [
              { path: '/', element: <QuantityBoughtAgainstPurchaseOrderReport /> }
            ]
          },
          {
            path: 'CategoryWiseQtyBoughtAgainstPurchaseOrder',
            children: [
              { path: '/', element: <CategoryWiseQtyBoughtAgainstPurchaseOrder /> }
            ]
          },
          {
            path: 'NetBenefitOfFCCPurchasesReport',
            children: [
              { path: '/', element: <NetBenefitOfFCCPurchasesReport /> }
            ]
          },
          {
            path: '/availabilityAgainstRequirement',
            children: [
              { path: '/', element: <AvailabilityAgainstRequirement /> }
            ]
          },
          {
            path: 'ViewMarket',
            children: [
              { path: '/', element: <MarketListing /> },
              { path: 'addedit/:operationEntityID', element: <MarketAddEdit /> }
            ]
          },
          {
            path: 'PriceComparisonReport',
            children: [
              { path: '/', element: <PriceComparisonReport /> }
            ]
          },
          {
            path: '/PriceApprovalReport',
            children: [
              { path: '/', element: <PriceApprovalReport /> }
            ]
          },
          {
            path: 'FinalStatusofSuplierPaymentReport',
            children: [
              { path: '/', element: <FinalStatusofSuplierPaymentReport /> }
            ]
          },
          {
            path: '/viewSellingPrice',
            children: [
              { path: '/', element: <MarketPriceListing /> },
              { path: 'addedit/:operationEntityID', element: <MarketPriceAddEdit /> }
            ]
          },
          {
            path: '/FCCIQVsOQReport',
            children: [
              { path: '/', element: <FCCIQVsOQReport /> },
            ]
          },
          {
            path: '/UncompleteGRNReport',
            children: [
              { path: '/', element: <UncompleteGRNReport /> },
            ]
          },
          {
            path: '/AnnualPlanForFCC',
            children: [
              { path: '/', element: <AnnualPlanForFCCReport /> }
            ]
          },
          {
            path: '/OrderAllocationConfiguration',
            children: [
              { path: '/', element: <OrderAllocationConfigurationListing /> },
              { path: 'addedit/:orderAllocationConfigurationID', element: <OrderAllocationConfigurationAddEdit /> }
            ]
          },
          {
            path: '/FDCInboundTransactionsReport',
            children: [
              { path: '/', element: <FDCInboundTransactionsReport /> },
            ]
          },
          {
            path: '/ViewPricing',
            children: [
              { path: '/', element: <PricingListing /> }
            ]
          },
          {
            path: 'viewCustomerOrdersOutletWise',
            children: [{ path: '/', element: <ViewCustomerOrdersOutletWise /> }]
          },
          {
            path: 'viewOutletOrders',
            children: [{ path: '/', element: <ViewOutletOrders /> }]
          },
          {
            path: 'route',
            children: [
              { path: '/', element: <RouteListing /> },
              { path: 'addedit/:routeID', element: <RouteAddEdit /> }
            ]
          },
          {
            path: '/fCCInboundTransactionsReportSKUwise',
            children: [
              { path: '/', element: <FCCInboundTransactionsReportSKUwise /> }
            ]
          },
          {
            path: '/QuantityVarianceReport',
            children: [
              { path: '/', element: <QuantityVarianceReport /> }
            ]
          },
          {
            path: '/fdcFccOutboundInvoice',
            children: [
              { path: '/', element: <ViewFDCFCCOutboundInvoice /> }
            ]
          },
          {
            path: 'GradeMaster',
            children: [
              { path: '/', element: <GradeMasterListing /> },
              { path: 'addedit/:gradeID', element: <GradeMasterAddEdit /> }
            ]
          },
          {
            path: 'stockBalanceReport',
            children: [
              { path: '/', element: <StockBalanceReport /> }
            ]
          },
          {
            path: 'supplierPaymentAuditReport',
            children: [
              { path: '/', element: <SupplierPaymentAuditReport /> }
            ]
          },
          {
            path: 'customerOrderDetailsView',
            children: [{ path: '/', element: <ViewOrderDetails /> }]
          },
          {
            path: 'RejectGRNDetailReport',
            children: [
              { path: '/', element: <RejectGRNDetailReport /> }
            ]
          },
          {
            path: 'PendingPackageDetailsReport',
            children: [
              { path: '/', element: <PendingPackageDetailsReport /> }
            ]
          },
          {
            path: 'OrderReallocationBreakdownReport',
            children: [
              { path: '/', element: <OrderReallocationBreakdownReport /> }
            ]
          },
          {
            path: 'customermaster',
            children: [
              { path: '/', element: <CustomerMasterListing /> },
              { path: 'addedit/:customerID', element: <CustomerMasterAddEdit /> }
            ]
          },
          {
            path: 'CustomerTypeMapping',
            children: [
              { path: '/', element: <CustomerTypeMappingListing /> },
              { path: 'addedit/:customerTypeMappingId', element: <CustomerTypeMappingAddEdit /> }
            ]
          },
          {
            path: '/InventoryHistoryReport',
            children: [
              { path: '/', element: <InventoryHistoryReport /> }
            ]
          },
          {
            path: 'CustomerOrderPanel',
            children: [
              { path: '/', element: <CustomerOrderPanelListing /> },
              { path: 'addedit/:customerOrderID', element: <CustomerOrderPanelAddEdit /> }
            ]
          },
          {
            path: '/CustomerOutletWiseOrderHistoryReport',
            children: [
              { path: '/', element: <CustomerOutletWiseOrderHistoryReport /> }
            ]
          },
          {
            path: 'StockManagement',
            children: [
              { path: '/', element: <StockManagement /> }
            ]
          },
          {
            path: 'StockAdjustment',
            children: [
              { path: '/', element: <StockAdjustmentListing /> },
              { path: 'addedit/:stockAdjustmentID', element: <StockAdjustmentAddEdit /> }
            ]
          }
        ]
      },
      {
        path: '/loaderView',
        element: <EmptyLayout />,
        children: [{ path: 'loader', element: <Loader /> }]
      },
      { path: '*', element: <Navigate to="/404" replace /> }
    ]);
  }
  return useRoutes([
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'login', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '/', element: <Navigate to="/loader" /> },
        { path: 'loader', element: <Loader /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    }
  ]);
}
